import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getHourlyDashboard = createAsyncThunk('hourlyDashboardSlice/getHourlyDashboard', async (params = {}) => {
    try {
        const response = await axios.get('/dashboard/call-dashboard', {
            params: {
                orderStatus: 'Customer',
                ...params
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const hourlyDashboardSlice = createSlice({
    name: 'hourlyDashboardSlice',
    initialState: {
        data: null,
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getHourlyDashboard.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getHourlyDashboard.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        });
        builder.addCase(getHourlyDashboard.rejected, (state) => {
            state.loading = false;
        });
    }
});

export default hourlyDashboardSlice.reducer;
